/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Inbound_Pickup_Not_EditableInputs */

const en_error_inbound_pickup_not_editable = /** @type {(inputs: Error_Inbound_Pickup_Not_EditableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The ready date and the pickup contact change here only while the inbound is on its way to the warehouse: from its submission until the warehouse receives it. In a draft, edit the inbound.`)
};

/**
* | output |
* | --- |
* | "The ready date and the pickup contact change here only while the inbound is on its way to the warehouse: from its submission until the warehouse receives it...." |
*
* @param {Error_Inbound_Pickup_Not_EditableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_inbound_pickup_not_editable = /** @type {((inputs?: Error_Inbound_Pickup_Not_EditableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Inbound_Pickup_Not_EditableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_inbound_pickup_not_editable(inputs)
});